import { Component, OnInit } from '@angular/core';
import { Crisp } from 'crisp-sdk-web';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  openChat() {
    Crisp.chat.open();
  }
}
